// Stable field order matches PRD sheet 3, items 1–48.
export const fields = ["uid","date","contractRate","spotRate","newRegistrations","registrations","newPartners","partners","newVerified","verified","chainIn","chainOut","netChain","newChainUsers","chainUsers","chainOutUsers","totalChainUsers","internalIn","internalOut","netInternal","netDeposit","newInternalUsers","internalUsers","internalOutUsers","totalInternalUsers","spotVolume","spotFee","newTraders","traders","totalTraders","contractVolume","contractFee","fundingFee","realizedPnl","netPnl","bonusFee","bonusFunding","bonusPnl","couponFee","couponPnl","deductedFee","netFee","adjustedPnl","estimatedRebate","paidRebate","afterRebatePnl","trialProfit","activityReward"]
export const columnLabels = [
  "UID",
  "统计日期",
  "合约返佣比例",
  "现货返佣比例",
  "新增注册人数",
  "总注册人数",
  "新增合伙人人数",
  "总合伙人人数",
  "新增实名认证人数",
  "总实名认证人数",
  "链上充值金额",
  "链上提现金额",
  "链上净充值金额",
  "新增链上充值人数",
  "链上充值人数",
  "链上提现人数",
  "总链上充值人数",
  "内部转入金额",
  "内部转出金额",
  "内部净转入金额",
  "用户净入金金额",
  "新增内部充值人数",
  "内部充值人数",
  "内部提现人数",
  "总内部充值人数",
  "现货交易额",
  "现货手续费",
  "新增合约交易人数",
  "合约交易人数",
  "总合约交易人数",
  "合约交易额",
  "合约手续费",
  "资金费",
  "合约平仓盈亏",
  "合约净盈亏",
  "体验金抵扣手续费",
  "体验金抵扣资金费",
  "体验金抵扣盈亏",
  "手续费券抵扣金额",
  "盈亏券抵扣金额",
  "合约扣减手续费",
  "抵扣后合约手续费",
  "抵扣后合约净盈亏",
  "预计返佣金额",
  "实际返佣金额",
  "返佣后合约净盈亏",
  "仓位体验券获利",
  "活动获得奖励"
]
export const messages = {
  "title": "合伙人数据统计",
  "legacy": "原交易统计",
  "daily": "日明细",
  "period": "时间段汇总",
  "partnerUid": "合伙人UID",
  "exactUid": "合伙人UID，精确搜索",
  "all": "全部",
  "ordinary": "普通用户",
  "simulated": "模拟用户（暂不支持）",
  "onlyOrdinary": "本期仅统计普通用户",
  "search": "查询",
  "reset": "重置",
  "columns": "列设置",
  "exportFiltered": "导出筛选结果",
  "exportAll": "导出全部",
  "summary": "汇总",
  "detail": "统计列表",
  "PARTNER": "合伙人汇总",
  "RETAIL": "散户",
  "TOTAL": "总计",
  "summaryType": "汇总类型",
  "start": "开始日期",
  "end": "结束日期",
  "to": "至",
  "notes": "统计口径说明",
  "allColumns": "全选",
  "restore": "恢复默认",
  "drag": "拖动调整列顺序；导出始终包含全部48列。",
  "amountHint": "金额单位 USDT · 截取4位小数",
  "empty": "暂无符合条件的数据",
  "failed": "查询失败，请稍后重试",
  "invalidUid": "UID只能输入正整数",
  "INVALID_RANGE": "请选择截至昨日、跨度不超过92天的有效日期",
  "INVALID_MODE": "统计模式无效",
  "REPORT_TOO_LARGE": "数据量超出单次查询上限，请缩小日期范围",
  "DEDUCTION_SCOPE": "扣减手续费按已有返佣明细的扣减标记去重汇总；缺少返佣明细的原手续费，仍无法确认历史扣减状态。",
  "ACTUAL_REBATE_SCOPE": "实际返佣按收款人及到账时间汇总现有返佣入账；历史到账尚不能完整拆分至合约、现货及交易来源。返佣后净盈亏沿用此到账口径。",
  "EXPORT_TOO_LARGE": "导出超过2万行，请缩小日期范围或筛选合伙人",
  "TENANT_REQUIRED": "登录状态已失效，请重新登录",
  "ORDINARY_ONLY": "只统计普通用户；汇总按用户及业务记录去重，不重复累加父子团队。",
  "LEGACY_FX": "充值、内部转账金额复用已有日统计折算值，历史非USDT金额不代表已验证到账时汇率。",
  "RETAINED_KYC": "实名人数基于现存通过记录；撤销、删除认证后的历史期末状态无法完整还原。",
  "IDENTITY_HISTORY": "身份与团队归属使用现有创建、迁移和归属记录；取消、恢复的完整历史仍有限制。",
  "DAILY_SNAPSHOT_OWNERSHIP": "当天发生归属变化：已有日统计金额按日末归属，无法在日内拆分。",
  "CONTRACT_VOLUME_CONFLICT": "合约成交额按成交业务键去重；所选范围有成交与订单不一致的历史记录，金额需结合原始记录复核。",
  "SPOT_TIME_UNVERIFIED": "存在尚未确认时间偏移的现货成交，请核对该日数据。",
  "MISSING_FX": "部分记录缺少USDT折算依据，相关金额显示为“—”。",
  "MISSING_RATE": "缺少对应日期返佣比例，预计返佣显示为“—”。",
  "DEDUCTION_CONFLICT": "原手续费的跨层扣减记录不一致，扣减金额显示为“—”。",
  "exportDone": "导出完成"
}
export function translate(key) { return messages[key] || key }
